import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ProductionItemRequestCancelledActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/ItemRequest/ItemRequestHistoryBrowser")
	}

	render() {
		return (
			<Activity 
				name="ItemRequestCompleted"
				RenderedComponent={this.RenderedComponent}
				context="cancelled"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ProductionItemRequestCancelledActivity)
